<template>
  <div class="contaniorn">
    <div style="margin-top: -13px;">
      <img style="height: 4px;width: 100%" src="../../static/img/t-bar.jpg" alt="">
    </div>
    <div class="header">
        <div class="header_img">
          <a href="http://www.kxwg123.com/#/">  <img src="../../static/img/logo.png" alt=""></a>
        </div>
        <div class="header_nav">
<!--          <ul>-->
<!--            <li v-for="(list,index) in navLists" class="nav" :class="{ red:changeRed == index}" @click="reds(index)">-->
<!--              {{list.text}}</li>-->
<!--          </ul>-->
<!--          <el-menu-->
<!--            :default-active="this.$route.path"-->
<!--            router-->
<!--            text-color="#000000"-->
<!--            active-text-color="#DF584D">-->
<!--            <el-menu-item v-for="(item,i) in navLists" :key="i" :index="item.url" :class="{ red:changeRed == item}" @click="reds(item)">-->
<!--              <template slot="title">-->
<!--                <span> {{ item.text }}</span>-->
<!--              </template>-->
<!--            </el-menu-item>-->

<!--          </el-menu>-->

          <el-menu router  :default-active="$route.meta.belong ? $route.meta.belong:$route.path" class="el-menu-demo" mode="horizontal" >
            <el-menu-item index="/" id="index">首页</el-menu-item>

            <el-submenu index="/ProRecommend">
                <template slot="title" >
                  <el-menu-item index="/ProRecommend">
                    开心玩国
                  </el-menu-item>
                </template>
              <el-menu-item-group>
                <div class="nav_headertop">
                  <div  style="cursor: pointer" @click="showdo('项目概述')"><a >项目概况</a></div>

                  <div style="cursor: pointer" @click="showdo('品牌简介')"><a >品牌简介</a></div>

                  <div style="cursor: pointer" @click="showdo('品牌文化')"><a >品牌文化</a></div>

                  <div style="cursor: pointer" @click="showdo('荣誉资质')"><a>资质荣誉</a></div>
                </div>

              </el-menu-item-group>

            </el-submenu>
<!--            <el-submenu :index="$route.fullPath.indexOf('/ProRecommending')>-1?$route.fullPath:'/le'">-->
            <el-submenu index="/le">
              <template slot="title" >
                <el-menu-item index="/le">
                  创新产品
                </el-menu-item>

              </template>

              <el-menu-item-group>
                <div class="nav_headertop">
                  <div style="cursor: pointer" @click="showdochuang('六大主题')"><a>六大主题</a></div>

                  <div style="cursor: pointer" @click="showdochuang('十大项目')"><a >十大项目</a></div>

                  <div style="cursor: pointer" @click="showdochuang('乐园图景')"><a >乐园图景</a></div>

                </div>

              </el-menu-item-group>

            </el-submenu>
              <el-submenu index="/add">
                <template slot="title" >
                  <el-menu-item index="/add">
                    财富世界
                  </el-menu-item>

                </template>

                <el-menu-item-group>
                  <div class="nav_headertop">
                    <div  style="cursor: pointer" @click="showdocai('市场前景')"><a >市场前景</a></div>

                    <div  style="cursor: pointer" @click="showdocai('行业趋势')"><a >行业趋势</a></div>

                    <div  style="cursor: pointer" @click="showdocai('投资优势')"><a >投资优势</a></div>

                  </div>

                </el-menu-item-group>

              </el-submenu>
              <el-submenu index="/Joinus">
                <template slot="title" >
                  <el-menu-item index="/Joinus">
                    加入我们
                  </el-menu-item>

                </template>

                <el-menu-item-group style="left: 1600px">
                  <div class="nav_headertop" style="left: 1600px">
                    <div @click="showshi('合作资质')"><a > 合作资质</a></div>

<!--                    <div><a :href="'#/Joinus?maodian=fzlc'" @click="nox1()">合作政策</a></div>-->

                    <div @click="showshi('合作步骤')"><a >合作步骤</a></div>
                    <div @click="showshi('扶持政策')"><a >扶持政策</a></div>
                    <div @click="showshi('营销赋能')"><a >营销赋能</a></div>
                  </div>

                </el-menu-item-group>

              </el-submenu>
            <el-menu-item index="/newadd?page=1">新闻资讯</el-menu-item>
            <el-submenu index="/contactus">
              <template slot="title" >
                <el-menu-item index="/contactus">
                  联系我们
                </el-menu-item>

              </template>

              <el-menu-item-group style="left: 1600px">
                <div class="nav_headertop" style="left: 1600px">
                  <div @click="showshiis('联系方式')"><a > 联系方式</a></div>
                  <div @click="showshiis('在线留言')"><a >在线留言</a></div>
                </div>

              </el-menu-item-group>

            </el-submenu>
          </el-menu>

        </div>
    </div>
  </div>
</template>

<script>
import {goAnchor,GetQueryString} from '../../static/js/common';
export default {
  name: 'Prohead',
  data () {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      navLists:[
        {
          "text":"首页",
          "url":'/'
        },
        {
          "text":"开心玩国",
          "url":'/ProRecommend',
        },
        {
          "text":"创新产品",
          "url":'/ProRecommending',

        },
        {
          "text":"财富世界",
          "url":'/add'
        },
        {
          "text":"加入我们",
          "url":'/Joinus'
        },
        {
          "text":"新闻资讯",
          "url":'/newadd'
        },
        {
          "text":"联系方式",
          "url":'contactus'
        }
      ],
      changeRed:0
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      // let maodian=this.GetQueryString('maodian');
      // console.log('11111111111111111',maodian)
      // if(maodian){
      //   this.goAnchor('#'+maodian);
      //
      // }
    });
  },
  methods:{
    goAnchor,

    GetQueryString,
    showdo(name){
      console.log(name)
      // window.href='#/ProRecommending?id='+name
      this.$nextTick(() => {
        this.$router.push('/ProRecommend?id='+name)
      });

    },
    showshiis(name){
      this.$nextTick(() => {
        this.$router.push('/contactus?id='+name)
      });
    },
    showdochuang(name){
      this.$nextTick(() => {
        this.$router.push('/le?id='+name)
      });
    },
    showdocai(name){
      this.$nextTick(() => {
        this.$router.push('/add?id='+name)
      });
    },
    showshi(name){
      this.$nextTick(() => {
        this.$router.push('/Joinus?id='+name)
      });
    },
    nox(){
      console.log(this.$route.query)
        const returnEle = document.querySelector("#gsjj");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
    },
    nox1(){
      console.log(this.$route.query)
      const returnEle = document.querySelector("#fzlc");  //productId是将要跳转区域的id
      if (!!returnEle) {
        returnEle.scrollIntoView(true); // true 是默认的
      }
    },
    nox2(){
      console.log(this.$route.query)
      const returnEle = document.querySelector("#ryzz");  //productId是将要跳转区域的id
      if (!!returnEle) {
        returnEle.scrollIntoView(true); // true 是默认的
      }
    },
    nox3(){
      console.log(this.$route.query)
      const returnEle = document.querySelector("#mtsy");  //productId是将要跳转区域的id
      if (!!returnEle) {
        returnEle.scrollIntoView(true); // true 是默认的
      }
    },
    nox4(){
      console.log(this.$route.query)
      const returnEle = document.querySelector("#ysfn");  //productId是将要跳转区域的id
      if (!!returnEle) {
        returnEle.scrollIntoView(true); // true 是默认的
      }
    },
    happy(){
      console.log('11111')
      this.$router.push('/ProRecommend')
    },
    reds:function(index){
      console.log(index)
      this.changeRed = index;
    }
  }
}
</script>

<style scoped>
.el-menu--horizontal:nth-of-type(2){
    background: forestgreen;
  //left: 1000px;
}
.nav_headertop{
  //width: 120px;
  background: #DF584D;

}
.nav_headertop li{
  height: 33px;
  text-align: center;
  padding: 4px;
  float: left;
  line-height: 36px;
  //border-bottom: .5px solid rgba(225,225,225,0.5);
  margin-left: 10px;
}
.el-menu-item:hover {
}
.nav_headertop li:hover{
  //font-weight: 800;
  color: #DF584D;
}
.nav_headertop li a:hover{
  color: #fff;
  background: #DF584D;

}
.nav_headertop li a{
  color: #000000;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
}
.el-menu--horizontal>.el-menu-item[data-v-ec6a74e6] {
   height: 70px !important;
}
  .red{
  color: #DF584D;
  border-bottom: 5px solid #DF584D;
}
.nav {
  line-height: 120px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
  text-align: center;
}


.el-menu {
  border-right: solid 1px #e6e6e6;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: none !important;
}
.contaniorn{
  background: #ffffff;
}
.header{
  height: 105px;
  width: 1300px;
  margin: 0 auto;
}
.header_img{
  width: 400px;
  float: left;
}
.header_img img{
  margin-top: 13px;
}
.header_nav{
  float: left;
}
.header_nav ul li{
  float: left;
  width: 120px;
  height: 70px;
  text-align: center;
  line-height: 90px;
  font-size: 20px;
}
.nav_headertop div{
  float: left;
  width: 95px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  font-size: 20px;
}
.nav_headertop div:hover{
//font-weight: 800;
  color: #DF584D;
}
.nav_headertop div a:hover{
  color: #fff;
  background: #DF584D;

}
.nav_headertop div a{
  color: #DF584D;
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
}
.header_nav ul li:hover{
  color: #DF584D;
  //border-bottom: 1px solid #DF584D !important;

}
.el-submenu__title li:hover{
  border-bottom: 1px solid #DF584D !important;

}
.el-menu .el-menu-item:hover {
  outline: 0;
  background-color: #ffffff !important;
  color: #DF584D !important;
  //border-bottom: 1px solid #DF584D;
}
.el-menu{
  border-right: none !important;
}
.el-menu--horizontal>.el-menu-item {
  //color: #000000 !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-menu--horizontal>.el-menu-item {
  float: left;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: #000000;
}
.el-menu-demo li:nth-child(1):hover{
  border-bottom: 2px solid #DF584D !important;
  cursor: pointer;
}
.el-menu-demo li:nth-child(6):hover{
  border-bottom: 2px solid #DF584D !important;
  cursor: pointer;
}
.el-menu-demo li:nth-child(7):hover{
  //border-bottom: 2px solid #DF584D !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Prohead.vue